<template>
    <div class="row">
        <b-col cols="12 mb-2" v-if="indumentariasElegidas && indumentariasElegidas.length > 0">
            <b>Observaciones de las indumentarias:</b> {{ items[0].observacion_indumentarias }}
        </b-col>
        <div class="col-12 col-lg-8 mb-4">
            <table class="table tabla-resumen table-bordered mb-1">
                <tr class="lightgray-content">
                    <th></th>
                    <th>Pedido</th>
                    <th class="price">Precio</th>
                </tr>

                <template v-for="(elem, index) in items">
                    <tr :key="index">
                        <td class="h1 text-center regular">{{ ++index }}</td>
                        <td>
                            <strong class="text-bold h5 d-block mb-1">{{
                                    elem.titulo
                            }}</strong>
                            <template v-if="elem.name">
                                <strong class="text-bold h7 d-block mb-1">{{
                                        elem.name
                                }}</strong>
                            </template>
                        </td>
                        <td>
                            <div class="h3 m-0">
                                {{ elem.precio | formatear_precio }}
                            </div>
                        </td>
                    </tr>
                </template>
                <template v-if="indumentariasElegidas && indumentariasElegidas.length > 0">
                    <tr v-for="(indumentaria, index) in indumentariasElegidas" :key="index + '-' + indumentaria.id">
                        <td class="text-center"><img :src="indumentaria.imagen" style="width: 50px;" alt=""></td>
                        <td>
                            <strong class="text-bold h5 d-block mb-1">{{ indumentaria.nombre }} <small style="font-size: 11px;">({{ indumentaria.unidades + (indumentaria.unidades > 1 ? ' unidades' : ' unidad')}})</small></strong>
                            <small><strong class="text-bold h7 d-block mb-1">Talla {{ indumentaria.talla.nombre }}</strong></small>
                        </td>
                        <td>
                            <div class="h3 m-0" v-if="indumentaria.incluida && indumentaria.unidades == 1">{{ '0' | formatear_precio  }}</div>
                            <div class="h3 m-0" v-else>{{ indumentaria.precio_total | formatear_precio }}</div>
                        </td>
                    </tr>
                </template>
                <tr>
                    <td colspan="2" style="text-align: right">
                        <span class="total-price h2 m-0">TOTAL: </span>
                    </td>
                    <td v-if="base.descuento_aplicado > 0 || base.descuento_integro > 0">
                        <div>
                            <del class="total-price h2 m-0">{{ indumentariasElegidas ? totalConIndumentarias : total | formatear_precio }}</del>
                            <span class="total-price h3">
                                <template v-if="base.descuento_aplicado > 0">
                                    (-{{ base.descuento_aplicado }}%)
                                </template>
                                <template v-else-if="base.descuento_integro > 0">
                                    (-{{ base.descuento_integro | formatear_precio }})
                                </template>
                            </span>
                        </div>
                        <span class="total-price h2 m-0">{{ importe_con_descuento | formatear_precio }}<small>*</small></span>
                    </td>
                    <td v-else>
                        <span class="total-price h2 m-0">{{ indumentariasElegidas ? totalConIndumentarias : total | formatear_precio }}<small>*</small></span>
                    </td>
                </tr>
            </table>
            <template v-for="(elem, index) in items">
                <ImporteConGd :gd_taquilla="gd_taquilla" :gd_online="gd_online" :importe="priceResumen" :key="index" id="importe-con-gd" />
            </template>
        </div>
    </div>
</template>

<script>
import ImporteConGd from "@/components/backend/components/ImporteConGd";

export default {
    props: ["base", "items", "indumentariasElegidas"],
    data() {
        return {
            error: false,
            gd_online: this.$store.getters.getGd['venta_bases_online'],
            gd_taquilla: this.$store.getters.getGd['venta_bases_fisica'],
        };
    },
    computed: {
        total() {
            let total = 0;
            for (let i in this.items) {
                if (this.gd_taquilla && !this.gd_taquilla.modalidad) {
                    total = total + (parseFloat(this.items[i].precio) + this.gd_taquilla.cantidad);
                } else if (this.gd_taquilla.modalidad) {
                    total = total + (parseFloat(this.items[i].precio) * this.gd_taquilla.cantidad / 100) + parseFloat(this.items[i].precio);
                } else {
                    total = total + parseFloat(this.items[i].precio);
                }
            }
            return total;
        },
        totalIndumentarias() {
            let total = 0;
            for (let i in this.indumentariasElegidas) {
                if (this.indumentariasElegidas[i].incluida && this.indumentariasElegidas[i].unidades == 1) {
                    total = total + 0;
                } else {
                    total = total + parseFloat(this.indumentariasElegidas[i].precio_total);
                }
            }
            return total;
        },
        totalConIndumentarias() {
            return this.total + this.totalIndumentarias;
        },
        importe_con_descuento() {
            let importe = 0;

            if (this.indumentariasElegidas) {
                importe = this.totalConIndumentarias;
            } else {
                importe = this.total;
            }

            if (this.base.descuento_aplicado != 0) {
                importe = importe - (importe * this.base.descuento_aplicado / 100);
            } else if (this.base.descuento_integro != 0) {
                importe = importe - this.base.descuento_integro;
            }

            return importe;
        },
        priceResumen() {
            if(this.base.descuento_aplicado > 0 || this.base.descuento_integro > 0) {
                if (this.gd_taquilla) {
                    if (!this.gd_taquilla.modalidad) {
                        return this.importe_con_descuento - this.gd_taquilla.cantidad;
                    } else {
                        return (parseFloat(this.importe_con_descuento) * this.gd_taquilla.cantidad / 100) + parseFloat(this.importe_con_descuento);
                    }
                }
                return this.importe_con_descuento;
            }

            let total = 0;

            if (this.indumentariasElegidas && this.indumentariasElegidas.length > 0) {
                total += this.items[0].precio + this.totalIndumentarias;
            } else {
                total += this.items[0].precio;
            }

            return total;
        }
    },
    created() {
        this.items[0].importe_total = this.indumentariasElegidas ? this.totalConIndumentarias : this.total
    },
    components: { ImporteConGd }
};
</script>
